import { createContext } from 'react';

import type { OrganizationFormValues } from '../model/types';

export type WizardMode = 'create' | 'edit';

export type WizardContextState = {
	data: OrganizationFormValues;
	setDataForStep: (
		step: keyof OrganizationFormValues,
		value: OrganizationFormValues[keyof OrganizationFormValues]
	) => void;
	mode: WizardMode;
};

export const WizardContext = createContext<WizardContextState | null>(null);
